import getIsiOSChrome from "selectors/device/getIsiOSChrome";
import { createSelector } from "reselect";

const getIsUIWebViewWithInlineVideo = createSelector(
  [getIsiOSChrome],
  (isiOSChrome) => isiOSChrome,
);

export default getIsUIWebViewWithInlineVideo;
